var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCaretUpdown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.733 19.644a.89.89 0 0 0 1.423 0l3.555-4.74A.89.89 0 0 0 16 13.482H8.889a.889.889 0 0 0-.711 1.422zm0-15.288a.89.89 0 0 1 1.423 0l3.555 4.74A.89.89 0 0 1 16 10.518H8.889a.889.889 0 0 1-.711-1.422z"
})));
export default SvgCaretUpdown;